// src\main.jsx
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ReadingTimeProvider } from './contexts/ReadingTimeContext';
import { ToastProvider } from './hooks/useToast';
import { router } from './routers/router';
import './index.css';
import './lib/chart';

// Import IBM Plex Sans
import '@fontsource/ibm-plex-sans/400.css'; // Regular
import '@fontsource/ibm-plex-sans/500.css'; // Medium
import '@fontsource/ibm-plex-sans/600.css'; // Semi-bold
import '@fontsource/ibm-plex-sans/700.css'; // Bold

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <AuthProvider>
      <ReadingTimeProvider>
        <ThemeProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </ThemeProvider>
      </ReadingTimeProvider>
    </AuthProvider>
  </HelmetProvider>,
);
